const nameValidation = (name) => name && name.replace(/\s/g, "").length > 0;
const usernamesFormatValidation = (usernames) => usernames.every((username) => !username.match(/\s/g));
const userIDsFormatValidation = (user_ids) => user_ids.every((user_id) => !user_id.match(/\s/g));
const emailAddressesFormatValidation = (email_addresses) => {
  const emailRegex = /^[\w-.]+@([\w-]+\.)+[\w-]+$/g;
  return email_addresses.every((email_address) => email_address.match(emailRegex));
};
const usernamesRequiredValidation = (usernames) => usernames.length > 0;
export function validations(values) {
  const errors = {};
  const { usernames, user_ids, email_addresses } = values.details;
  if (!nameValidation(values.name)) errors.name = "Asset Name is required";
  if (!usernamesRequiredValidation(usernames)) {
    errors.details = { usernames: "At least one Username is required" };
  } else {
    if (!usernamesFormatValidation(usernames))
      errors.details = { ...errors.details || {}, usernames: "Usernames cannot contain spaces" };
    if (!userIDsFormatValidation(user_ids))
      errors.details = { ...errors.details || {}, user_ids: "User IDs cannot contain spaces" };
    if (!emailAddressesFormatValidation(email_addresses))
      errors.details = { ...errors.details || {}, email_addresses: "Email Addresses must be valid" };
  }
  return errors;
}
